// Shared chrome for the installer-side surfaces: the Vistron brand mark and the
// topbar. Keeps the header identical across pages.

export function BrandMark() {
  return (
    <img src={`${process.env.PUBLIC_URL}/vistron.svg`} alt="Vistron" />
  );
}

export function InstallerTopbar({ title = 'سامانه FTTX', sub, action }) {
  return (
    <div className="inst-top">
      <div className="inst-mark"><BrandMark /></div>
      <div className="inst-top-text">
        <h2 className="inst-top-title">{title}</h2>
        {sub && <span className="inst-top-sub">{sub}</span>}
      </div>
      {action && <div className="inst-top-action">{action}</div>}
    </div>
  );
}
